import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ForWhoSection() {
  const isFor = ['Sos principiante y querés aprender a leer el tarot desde cero con bases sólidas.', 'Ya leés las cartas de forma intuitiva pero buscás estructurar tu conocimiento.', 'Sos terapeuta holística, astróloga o coach y querés sumar el tarot a tus sesiones.', 'Querés usar el tarot como herramienta de autoconocimiento y desarrollo personal.', 'Buscás material claro, directo y sin relleno que puedas consultar fácilmente.', 'Soñás con dar el salto y empezar a cobrar por tus lecturas de forma profesional.'];
  return <section className="px-4 py-12" data-id="element-108">
      <div className="max-w-5xl mx-auto" data-id="element-109">
        <h2 className="mb-8 text-3xl font-bold text-center md:text-4xl text-brand-teal" data-id="element-110">
          ¿Para quién es este MegaPack?
        </h2>

        <div className="max-w-2xl mx-auto" data-id="element-111">
          <div className="p-8 bg-[#1a1a1a] border rounded-2xl border-brand-teal/20 shadow-sm" data-id="element-112">
            <h3 className="mb-6 text-2xl font-bold text-brand-teal" data-id="element-113">
              ES PARA VOS SI:
            </h3>
            <ul className="space-y-4" data-id="element-114">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-115">
                  <CheckCircle2 className="w-6 h-6 text-brand-teal shrink-0 mt-0.5" data-id="element-116" />
                  <span className="text-brand-dark/90 leading-relaxed" data-id="element-117">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}